export default __webpack_public_path__ + "static/media/diagram1_eng.2a6f08c9.png";